import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component
} from '@angular/core'

import { CounterResponse } from '../../shared/counter'
import { CounterService } from '../../services/counter.service'
import { LegalSystemPage } from '../../shared/legal-system.model'
import { LegalSystemsService } from '../../services/legal-systems.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {
  title = 'Types of Legal Systems'
  page$!: Observable<LegalSystemPage>
  counterValue = 0
  loading = true

  constructor (
    private legal: LegalSystemsService,
    private counterService: CounterService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit (): void {
    this.page$ = this.legal.getByKey('home')

    this.counterService.increment().subscribe({
      next: (res: CounterResponse) => {
        this.counterValue = res.value
        this.loading = false
        this.cdr.markForCheck()
      },
      error: () => {
        this.counterService.get().subscribe({
          next: (res: CounterResponse) => {
            this.counterValue = res.value
          },
          complete: () => {
            this.loading = false
            this.cdr.markForCheck()
          }
        })
      }
    })
  }

  trackById (index: number, item: { id: number }): number {
    return item.id
  }

  trackByIndex (index: number): number {
    return index
  }
}
